"use client";

import { TimelineContainer } from "./timeline-container";
import { TransferItineraryInner } from "./transfer-itinerary-inner";
import { iTransferLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function TransferItinerary(
  props: iTransferLegDetails & { primaryColor?: string; day: number }
) {
  return (
    <TimelineContainer
      title={props.title || "Transfer"}
      icon={(props.icon as any) || "car"}
    >
      <TransferItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
